(function($) {
  "use strict";
  var accordionItem = $('.accordion .accordion__item')
  var accordionQuestion = $('.accordion .accordion__question')
  var accordionAnswer = $('.accordion .accordion__answer')

  // Hide answers.
  accordionAnswer.hide();

  // Click on a question and show the answer.
  accordionQuestion.click(function() {
    if ($(this).parent().hasClass('is-active')) {
      $(this).removeClass('is-active');
      accordionAnswer.slideUp();
      accordionItem.removeClass('is-active');
    } else {
      accordionAnswer.slideUp();
      $(this).siblings().slideDown();
      accordionItem.removeClass('is-active');
      $(this).parent().addClass('is-active');
    }
  });
})(jQuery);
